import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, StatusBar } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useNavigation } from '@react-navigation/native';
import { RESIDENTS_MOBILE_COLORS } from '@/constants/residents/mobile/color';
import { PaymentIcons } from './PaymentIcons';

interface MobileScreenHeaderProps {
  title: string;
  onBack?: () => void;
  showBackButton?: boolean;
}

/**
 * Shared mobile screen header component
 * Provides consistent header layout across payment screens
 */
export const MobileScreenHeader: React.FC<MobileScreenHeaderProps> = ({ title, onBack, showBackButton = true }) => {
  const navigation = useNavigation();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigation.goBack();
    }
  };

  return (
    <>
      <StatusBar barStyle="dark-content" backgroundColor={RESIDENTS_MOBILE_COLORS.BACKGROUND_PRIMARY} />
      <SafeAreaView edges={['top']} style={styles.headerSafeArea}>
        <View style={styles.header}>
          {showBackButton ? (
            <TouchableOpacity onPress={handleBack} style={styles.backButton}>
              <PaymentIcons.ChevronLeft />
            </TouchableOpacity>
          ) : (
            <View style={styles.headerLeft} />
          )}
          <Text style={styles.headerTitle}>{title}</Text>
          <View style={styles.headerRight} />
        </View>
      </SafeAreaView>
    </>
  );
};

const styles = StyleSheet.create({
  headerSafeArea: {
    backgroundColor: RESIDENTS_MOBILE_COLORS.BACKGROUND_PRIMARY,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  backButton: {
    padding: 4,
  },
  headerLeft: {
    width: 32,
  },
  headerTitle: {
    fontSize: 17,
    fontWeight: '600',
    color: RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY,
  },
  headerRight: {
    width: 32,
  },
});

